import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

export default function MyInterviewsPage() {
    const [interviews, setInterviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    useEffect(() => {
        const fetchInterviews = async () => {
            const token = localStorage.getItem('skillmatch_token');
            try {
                // ✅ Gọi API thật: Lấy danh sách ứng tuyển của tôi
                const res = await fetch(`${API_URL}/api/candidates/me/applications`, { 
                    headers: { 'x-auth-token': token } 
                });
                
                if (res.ok) {
                    const data = await res.json();
                    // Lọc những đơn có trạng thái "Phỏng vấn" hoặc đã có lịch (dù đã accept)
                    const interviewsData = data.filter(item => 
                        item.status === 'Phỏng vấn' && item.interview // Chỉ lấy cái nào có object interview
                    );
                    setInterviews(interviewsData);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchInterviews();
    }, [API_URL]);

    if (loading) return (
        <div className="min-h-screen pt-24 flex items-center justify-center bg-[#F8FAFC]">
            <span className="material-symbols-outlined animate-spin text-3xl text-blue-600">sync</span>
        </div>
    );

    return (
        <div className="min-h-screen bg-[#F8FAFC] pt-28 pb-10 px-4">
            <div className="max-w-4xl mx-auto">
                <div className="flex items-center justify-between mb-8">
                    <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
                        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600">
                            <span className="material-symbols-outlined">calendar_month</span>
                        </div>
                        Lịch phỏng vấn của tôi
                    </h1>
                    <div className="text-sm text-gray-500">
                        Bạn có <strong className="text-blue-600">{interviews.length}</strong> lịch hẹn
                    </div>
                </div>

                {interviews.length === 0 ? (
                    <div className="bg-white rounded-2xl p-12 text-center shadow-sm border border-gray-100 flex flex-col items-center">
                        <div className="w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-4">
                            <span className="material-symbols-outlined text-4xl text-gray-300">event_busy</span>
                        </div>
                        <h3 className="text-lg font-semibold text-gray-900">Chưa có lịch phỏng vấn nào</h3>
                        <p className="text-gray-500 mt-2 mb-6 max-w-sm">Hiện tại bạn chưa nhận được lời mời phỏng vấn nào. Hãy tiếp tục ứng tuyển nhé!</p>
                        <Link to="/jobs" className="px-6 py-2.5 bg-blue-600 text-white rounded-xl font-medium hover:bg-blue-700 transition-all shadow-lg shadow-blue-200">
                            Tìm việc ngay
                        </Link>
                    </div>
                ) : (
                    <div className="grid gap-5">
                        {interviews.map(item => (
                            <div key={item._id} className="bg-white p-6 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-all group">
                                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                                    <div className="flex gap-4">
                                        {/* Icon trạng thái */}
                                        <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${item.interview?.status === 'Accepted' ? 'bg-green-100 text-green-600' : 'bg-blue-50 text-blue-600'}`}>
                                            <span className="material-symbols-outlined text-2xl">
                                                {item.interview?.status === 'Accepted' ? 'check_circle' : 'mark_email_unread'}
                                            </span>
                                        </div>
                                        
                                        <div>
                                            <h3 className="font-bold text-lg text-gray-900 group-hover:text-blue-600 transition-colors">
                                                {item.jobId?.title || item.position}
                                            </h3>
                                            <div className="flex items-center gap-2 text-gray-600 font-medium mt-0.5">
                                                <span className="material-symbols-outlined text-[18px]">business</span>
                                                {item.jobId?.companyName || "Công ty tuyển dụng"}
                                            </div>
                                            
                                            {/* Thời gian & Địa điểm */}
                                            <div className="flex flex-wrap items-center gap-4 mt-3 text-sm text-gray-500">
                                                <span className="flex items-center gap-1.5 bg-gray-50 px-2 py-1 rounded text-gray-700">
                                                    <span className="material-symbols-outlined text-[16px] text-blue-500">event</span>
                                                    {new Date(item.interview?.time).toLocaleString('vi-VN', { weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute:'2-digit' })}
                                                </span>
                                                <span className="flex items-center gap-1.5">
                                                    <span className="material-symbols-outlined text-[16px] text-purple-500">
                                                        {item.interview?.type === 'Online' ? 'videocam' : 'apartment'}
                                                    </span>
                                                    {item.interview?.type}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <button 
                                        onClick={() => navigate(`/candidate/interviewed/${item._id}`)}
                                        className="w-full md:w-auto px-5 py-2.5 bg-white border border-gray-200 text-gray-700 font-medium rounded-xl hover:border-blue-500 hover:text-blue-600 hover:bg-blue-50 transition-all flex items-center justify-center gap-2"
                                    >
                                        Xem chi tiết
                                        <span className="material-symbols-outlined text-[18px]">arrow_forward</span>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}